import { AnimatedSprite, Assets, Container, Texture } from "pixi.js";
import type { WaterLayerData } from "../api/types";

export class WaterLayer extends Container {
  private sprite: AnimatedSprite | null = null;
  private running = true;

  setRunning(active: boolean): void {
    this.running = active;
    if (!this.sprite) return;
    if (active && this.data.frames.length > 1) this.sprite.play();
    else this.sprite.stop();
  }

  constructor(private readonly data: WaterLayerData) {
    super();
    this.label = "water-layer";
  }

  async build(): Promise<void> {
    if (!this.data.enabled || !this.data.frames.length) return;
    try {
      const textures = await Promise.all(
        this.data.frames.map((url) => Assets.load<Texture>(url)),
      );
      // In-flight image requests can resolve after the city was destroyed.
      if (this.destroyed) return;
      this.sprite = new AnimatedSprite(textures);
      this.sprite.anchor.set(0.5);
      this.sprite.position.set(this.data.offsetX, this.data.offsetY);
      this.sprite.scale.set(this.data.scale);
      this.sprite.alpha = this.data.opacity;
      this.sprite.animationSpeed = Math.max(
        0.02,
        Math.min(2, 16.667 / Math.max(40, this.data.frameDuration)),
      );
      if (this.running && textures.length > 1) this.sprite.play();
      this.addChild(this.sprite);
    } catch {
      // Optional water art must never block the city.
    }
  }

  destroy(options?: Parameters<Container["destroy"]>[0]): void {
    this.sprite?.stop();
    super.destroy(options);
  }
}
